import type { LabType } from './epidemiology.types';

export { LAB_TYPE } from './epidemiology.types';

export enum SearchType {
  Center = 'C',
  User = 'A',
}

export interface IGetPatientListRequest {
  history?: string;
  lastName?: string;
  name?: string;
  externalHistory?: string;
  gender?: string;
  birthDate?: Date
  extractionFrom?: Date;
  extractionTo?: Date;
  searchByUser?: boolean;
  centroId?: number | null;
}

export interface IGetPatientListRequestSaved {
  history?: string;
  lastName?: string;
  name?: string;
  externalHistory?: string;
  gender?: string;
  birthDate?: string
  extractionFrom?: string;
  extractionTo?: string;
  searchByUser?: boolean;
}

export interface IGetPatientListByRequest {
  labRequestFrom?: string;
  labRequestTo?: string;
  centerRequestFrom?: string;
  centerRequestTo?: string;
  extractionFrom?: Date;
  extractionTo?: Date;
  searchType?: SearchType;
  centroId?: number | null;
  historia?: string;
}

export interface IGetPatientListByRequestSaved {
  extractionFrom?: string;
  extractionTo?: string;
  labRequestFrom?: string;
  labRequestTo?: string;
  centerRequestFrom?: string;
  centerRequestTo?: string;
  searchType?: SearchType;
}

export interface IPatientHistory {
  nombre: string;
  limite: number;
  edad: number;
  errorMsg: string;
  historia: string;
  fechaNac: any;
  sexo: string;
  versNr: string;
  apellidos: string;
  notFallNr: string;
  pseudoVersNr: string;
  errorNr: number;
  columnas: string;
  orden: string;
}

export interface IPatientRequest {
  resStat: string;
  apellidosPaciente: string;
  materialname?: string;
  materialName?: string;
  sitio: string;
  petCentro: string;
  notfall: string;
  labMicro: number;
  errorMsg: string;
  statname: string;
  statName?: string;
  historia: string;
  labor: number;
  estado: string;
  historiaCentro: string;
  cEinDat: Date;
  nombrePaciente: string;
  peticion: string;
  einDat: Date;
  ndocs: number;
  /** Texto de alertas del SP (lista de peticiones). */
  alertas?: string;
  estadoPeticion: string;
  ancho: string;
  impreso: string;
  laboratorio: string;
  errorNr: number;
  display: string;
  columnas: string;
  orden: string;
  /** Tipo de laboratorio (LABC, LABM, LABG). Para visibilidad botón Acumulados y combo en diálogo 2.2. */
  labType?: LabType;
}

export interface IPatientRequestDetail {
  resStat: string;
  aZ: string;
  apellidosPaciente: string;
  auftrNr: number;
  materialname: string;
  sitio: string;
  petCentro: string;
  notfall: string;
  labMicro: number;
  labName: string;
  errorMsg: string;
  statname: string;
  historia: string;
  labor: number;
  estado: string;
  historiaCentro: string;
  cEinDat: Date;
  nombrePaciente: string;
  peticion: string;
  einDat: string;
  ndocs: number;
  estadoPeticion: string;
  ancho: string;
  impreso: string;
  laboratorio: string;
  errorNr: number;
  display: string;
  tests: IPatientRequestTest[];
  materiales: IPatientRequestMaterial[];
  signatures: Signature[];
  labNr: number;
  arztName?: string;
  diagnose?: string;
  info1?: string;
  /** Tipo de laboratorio (LABC, LABM, LABG). Si no viene del SP, se puede inferir desde labName/statname. */
  labType?: LabType;
}

export interface IPatientRequestMaterial {
  recepcio: Date;
  methname: string;
  materialNr: number;
  tests: IPatientRequestTest[];
  antibioticos: Antibiotic[];
  signatures?: Signature[];
}

// {
//   "": "Streptococcus dysgalactiae#*",
//   "printSeq": 137,
//   "columna14": "",
//   "columna15": "",
//   "columna12": "",
//   "columna13": "",
//   "columna10": "",
//   "columna11": "",
//   "columna20": "",
//   "columna18": "",
//   "columna19": "",
//   "columna2": "",
//   "columna16": "",
//   "columna1": "Sensible",
//   "columna17": "",
//   "methname": "Clindamicina",
//   "columna4": "",
//   "columna3": "",
//   "columna6": "",
//   "columna5": "",
//   "columna8": "",
//   "columna7": "",
//   "columna9": ""
// },
export type Antibiotic = {
  ''?: string;
  methname: string;
  printSeq: number;
  columna1: string;
  [key: `columna${number}`]: string | undefined;
};

export interface IGetPatientRequestDetailRequest {
  laboratory: string;
  idRequest: string;
  laboratoryNumber: string;
  date: string;
  impreso: string;
  sitio: string;
}

// {
//   "res_Prev": "Negatiu",
//   "pat": 0,
//   "zaehlerR": 30900,
//   "metname": "Aloanticossos per CDC (especificitat)",
//   "errorMsg": "",
//   "unidades": "",
//   "statusMedVal": 1,
//   "zusText": 0,
//   "resultado": "Negativo",
//   "metodo": 17074,
//   "valid": "jlcaro",
//   "dias": "364",
//   "restyp": 4,
//   "rangos": "",
//   "errorNr": 0
// }

export interface IPatientRequestTest {
  res_Prev: string;
  pat: number;
  zaehlerR: number;
  metname: string;
  errorMsg: string;
  unidades: string;
  statusMedVal: number;
  zusText: number;
  resultado: string;
  metodo: number;
  valid: string;
  dias: string;
  restyp: number;
  rangos: string;
  errorNr: number;
  mikrotyp?: string;
}

// {
//   "kuerzel": "FACR",
//   "errorMsg": "",
//   "errorNr": 0,
//   "name": "Facultativo Responsable"
// }
export type Signature = {
  kuerzel: string;
  errorMsg: string;
  errorNr: number;
  name: string;
};

/** Fila del result set de wspi_Search_Cumu (acumulados). */
export interface IAcumuladosRow {
  RequisCol: number;
  TestRow: number;
  RequisNr: string;
  ExtRequisNr: string;
  RequisSite?: string;
  EntryDate: string;
  TestNr: number;
  TestName: string;
  Units: string;
  PrintSeq?: number;
  Pathology: number;
  Result: string | number;
  NormalRange?: string;
  UpperLimit?: number;
  LowerLimit?: number;
  ResType: number;
}
